import { Component, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import { OrdersItemsDetailDTO } from 'src/app/admin-api';
import { IntegrationControllerService } from 'src/app/admin-api/api/integrationController.service';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-order-items-search',
  templateUrl: './order-items-search.component.html',
  styleUrl: './order-items-search.component.scss',
  providers: [MessageService]
})
export class OrderItemsSearchComponent implements OnInit {
  private integrationService: IntegrationControllerService = inject(
    IntegrationControllerService
  );
  private title: Title = inject(Title);

  chaveNfControl = new FormControl('', [
    Validators.required,
    Validators.minLength(44),
    Validators.maxLength(44),
    Validators.pattern(/^[0-9]{44}$/)
  ]);
  orderItems: OrdersItemsDetailDTO[] = [];
  hasSearched = false;
  isDetailedView = false;
  filteredChaveNf = '';

  ngOnInit(): void {
    this.title.setTitle('Integrações - Consulta de Pedido por Chave da NF');
  }

  get totalQuantity(): number {
    return this.orderItems.reduce(
      (total, item) => (total += item.productQuantity || 0),
      0
    );
  }

  async searchOrderItems(): Promise<void> {
    if (this.chaveNfControl.invalid || !this.chaveNfControl.value) {
      this.chaveNfControl.markAsTouched();
      return;
    }

    const chaveNf = this.chaveNfControl.value.trim();

    if (chaveNf.length !== 44) {
      AppDialogService.showErrorDialog({
        message: 'A chave da nota fiscal deve ter exatamente 44 dígitos.'
      });
      return;
    }

    try {
      LoaderService.showLoader();
      this.hasSearched = false;

      const response = await lastValueFrom(
        this.integrationService.getOrdersItemsByChaveNf(chaveNf)
      );

      this.orderItems = response.result || [];
      this.hasSearched = true;

      this.filteredChaveNf = chaveNf;
      this.chaveNfControl.reset();
      this.chaveNfControl.markAsUntouched();

      setTimeout(() => {
        const inputElement = document.getElementById(
          'chaveNf'
        ) as HTMLInputElement;
        if (inputElement) {
          inputElement.focus();
        }
      }, 100);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
      this.orderItems = [];
      this.hasSearched = true;
    } finally {
      LoaderService.showLoader(false);
    }
  }

  clearSearch(): void {
    this.chaveNfControl.reset();
    this.chaveNfControl.markAsUntouched();
    this.orderItems = [];
    this.hasSearched = false;
    this.filteredChaveNf = '';
  }

  toggleView(): void {
    this.isDetailedView = !this.isDetailedView;
    if (this.chaveNfControl.untouched === false && !this.chaveNfControl.value) {
      this.chaveNfControl.markAsUntouched();
    }
  }
}
